import * as React from 'react';
export const SelectIndexContext = /*#__PURE__*/React.createContext(undefined);
export function useSelectIndexContext() {
  const context = React.useContext(SelectIndexContext);
  if (context === undefined) {
    throw new Error('Base UI: SelectIndexContext is missing. Select parts must be placed within <Select.Root>.');
  }
  return context;
}